import { Box, Button, PasswordInput } from "@mantine/core";
import { useState } from "react";
import { Link } from "react-router";
import { PasswordResetLayout } from "../Layout/PasswordResetLayout";
import { PublicLayout } from "../Layout/PublicLayout";
import { useSetPass } from "./hooks/useSetPass";
import { PasswordRequirementsList } from "./PasswordRequirementsList";
import { setPasswordConfirm } from "./utils/setPasswordConfirm";

function SetPasswordConfirm() {
  const [newPass, setNewPass] = useState<string>("");
  const [newPassConfirm, setNewPassConfirm] = useState<string>("");

  const {
    handleSetPass,
    isSettingPass,
    isPasswordSet,
    errors,
    isChecked,
    validationErrors,
    isInvalidPass
  } = useSetPass({
    newPass,
    newPassConfirm,
    onPasswordSet: setPasswordConfirm
  });

  return (
    <PublicLayout>
      <PasswordResetLayout
        description={
          isPasswordSet ? (
            <>
              Ihr Passwort wurde gesetzt. Sie können sich jetzt mit dem Passwort{" "}
              <Link to="/login">einloggen</Link>.
            </>
          ) : (
            "Bitte wählen Sie das Passwort, mit dem Sie sich anmelden möchten:"
          )
        }
        title={isPasswordSet ? "Passwort gesetzt" : "Passwort setzen"}
      >
        {!isPasswordSet && (
          <form className="PasswordResetForm" onSubmit={handleSetPass}>
            <Box mb="1rem">
              <PasswordInput
                error={isInvalidPass}
                label="Neues Passwort"
                name="newPass"
                required
                value={newPass}
                withAsterisk={!newPass}
                onChange={(event) => setNewPass(event.currentTarget.value)}
              />

              <PasswordRequirementsList
                isChecked={isChecked}
                validationErrors={validationErrors}
              />

              <PasswordInput
                error={
                  isChecked && validationErrors.passwordsDoNotMatch
                    ? "Die eingegebenen Passwörter stimmen nicht überein."
                    : false
                }
                label="Neues Passwort bestätigen"
                name="newPassConfirm"
                required
                value={newPassConfirm}
                withAsterisk={!newPassConfirm}
                onChange={(event) =>
                  setNewPassConfirm(event.currentTarget.value)
                }
              />

              {errors}

              <div className="SubmitBtnWrapper">
                <Button
                  className="PasswordSubmitBtn"
                  color="primary"
                  disabled={!newPass && !newPassConfirm}
                  loading={isSettingPass}
                  type="submit"
                >
                  Passwort setzen
                </Button>
              </div>
            </Box>
          </form>
        )}
      </PasswordResetLayout>
    </PublicLayout>
  );
}

export { SetPasswordConfirm };
